import React, { Component, useEffect } from 'react';
import * as firebase from 'firebase';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from '../view/NavBar';
import { AffiliateViewTags } from '../view/AffiliateViewTags';
import {
    BrowserRouter as Router,
    useLocation,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";
import SmartGallery from 'react-smart-gallery';
import moment from 'moment';
import '../view/css/AffiliateView.css'
import { Eventfeed3 } from '../view/eventfeed3.js'


export const AffiliateView = (props) => {

    const [type_1, setType] = React.useState("");
    const [userLoaded, setUserLoaded] = React.useState(false);
    const [subscribed, setSubscribed] = React.useState(false);

    const [affiliateLoaded, setAffiliateLoaded] = React.useState(false);
    const [username, setUserName] = React.useState("");
    const [profile_pic, setPicture] = React.useState("");
    const [interests, setInterests] = React.useState([]);
    const [photos, setPhotos] = React.useState([]);
    const [description, setDescription] = React.useState("");
    const [eventy, setEvents] = React.useState([]);
    const [stop_store_event, setStore] = React.useState(false);

    const loadAffiliateDetail = () => {
        const db = firestore.collection("Users").doc(location.state.id);
        console.log(location.state.id);
        const doc = db.get().then(function (doc) {
            if (doc.exists) {
                setUserName(doc.data().username);
                setPicture(doc.data().profile_pic);
                setInterests(doc.data().interests);
                setPhotos(doc.data().photos);
                setDescription(doc.data().description);

                setAffiliateLoaded(true);
            } else {
                console.log("NOTHING EXISTS");
            }

        }).catch(function (error) {
            console.log("Error getting document:", error);
        });
    }


    const location = useLocation();

    var firestore = firebase.firestore();
    var user = firebase.auth().currentUser;

    const runThis = () => {
        if (user) {
            // console.log("loggedin")
            const db = firestore.collection("Users").doc(user.email);
            const doc = db.get().then(function (doc) {
                if (doc.exists) {
                    setType(doc.data().type);
                    if (doc.data().subscriptions.includes(location.state.id)) {
                        setSubscribed(true);
                    }
                    console.log("User loaded in Affiliate View: " + userLoaded);
                    if (type_1 === "Affiliate") {

                    }

                } else {
                    console.log("NOTHING EXISTS");
                }

            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
            setUserLoaded(true);
        }
    }

    const get_events = () => {
        const array_event = [];
        var stop_rend = false;
        const today_date = moment(new Date().now);

        const ab = firestore.collection("Event");
        const query = ab.orderBy("event_start");
        query.get().then(data => {
            if (!stop_rend) {
                data.forEach(doc => {
                    const doccer = doc.data();
                    const sub_name = location.state.id
                    const start_date = moment(doccer.event_start.toDate());
                    const end_date = moment(doccer.event_end.toDate());

                    if (doccer.Affiliate === sub_name && ((start_date.isSameOrAfter(today_date)) || (end_date.isAfter(today_date)))) {
                        console.log(doc.data().event_title)
                        array_event.push({
                            title: doccer.event_title,
                            location: doccer.location,
                            description: doccer.description,
                            start: start_date.format("MMM D, YYYY [at] h:mm a"),
                            end: end_date.format("MMM D, YYYY [at] h:mm a"),
                            affiliate: doccer.Affiliate,
                            pictures: doccer.picture
                        })
                    }
                })
                let unique = array_event.filter((e, i) => array_event.indexOf(e) === i);
                stop_rend = true;
                setEvents(unique)
            }
        })
        setStore(true);
    }

    const clickSubscribe = () => {
        //updates subscribe list of student
        var subscriptionRef = firestore.collection("Users").doc(user.email);
        subscriptionRef.update({
            subscriptions: firebase.firestore.FieldValue.arrayUnion(location.state.id)
        });

        //updates subscribers list of affiliate
        const subscribersRef = firestore.collection("Users").doc(location.state.id);
        subscribersRef.update({
            students: firebase.firestore.FieldValue.arrayUnion(user.email)
        })
        setSubscribed(true);
    }

    const clickUnsubscribe = () => {
        //updates subscribe list of student
        var subscriptionRef = firestore.collection("Users").doc(user.email);
        subscriptionRef.update({
            subscriptions: firebase.firestore.FieldValue.arrayRemove(location.state.id)
        });

        //updates subscribers list of affiliate
        const subscribersRef = firestore.collection("Users").doc(location.state.id);
        subscribersRef.update({
            students: firebase.firestore.FieldValue.arrayRemove(user.email)
        })
        setSubscribed(false);
    }

    return (
        <div className="viewprofile">
            {!userLoaded && runThis()}
            {!affiliateLoaded && loadAffiliateDetail()}
            {!stop_store_event && get_events()}
            <div className="NavBar">
                {type_1 === "" ? <NavBarGuest /> : type_1 === "Student" ? <NavBarUser /> : <NavBarAffiliate />}
            </div>

            {/* {photos.map((photo) => (
        <img src={photo} className="IndividualPhotos"/>
      ))} */}
            <div className="SmartGallery">
                <SmartGallery width="100%" images={photos} />
            </div>

            <div className="profilesection">
                <div className="ProfilePicture">
                    <img alt="profile" src={profile_pic} className="AffiliatePicture" />
                </div>
                <div className="clubcontainer">
                    <div className="clubname">{username}</div>
                </div>
                <div className="subsorview">
                    {type_1 === "" ? <div></div> : type_1 === "Affiliate" ? <div></div> : !subscribed ? <button className="subscribe" onClick={clickSubscribe}>Subscribe</button> : <button className="subscribe" onClick={clickUnsubscribe}>Unsubscribe</button>}
                    <Link className="viewgal" to={{ pathname: `/AffiliateGallery/${username}`, state: { id: location.state.id } }} >View Gallery</Link>
                </div>
            </div>
            <div className="tagsection">
                <div className="TagsTitle">Tags:</div>
                {interests.map((interests) => (
                    <AffiliateViewTags value={interests} email={location.state.id} />
                ))}
            </div>
            <div className="descriptionsection">
                <div className="description"><h2 className="destext" >{description} </h2>  <hr className="line" /></div>
                <div className="socials">Follow Us!
                    <div className="social1">
                        <img alt="ig" className="instagram" src="https://th.bing.com/th/id/OIP.ZLE44k87Gp4CtVdS0zkDpwHaHa?w=180&h=180&c=7&o=5&pid=1.7" />
                    </div>
                    <div><img alt="fb" className="Facebook" src="https://th.bing.com/th/id/OIP.wOPYZ0FBrg5cMj5uwD00nwHaHa?w=164&h=180&c=7&o=5&pid=1.7" /> </div>
                    <div><img alt="twitter" className="Twitter" src="http://martinliebermandotcom.files.wordpress.com/2013/03/twitter_logo.jpg" /> </div>
                    <div> <img alt="yt" className="Youtube" src="https://th.bing.com/th/id/OIP.OY9iyBbwTd7dUkum8HbP2QHaHa?w=177&h=180&c=7&o=5&pid=1.7" /> </div>
                    <div> <img alt="disc" className="Discord" src="https://wheretoinvest.money/wp-content/uploads/2017/12/discord-logo-1024x1024.png" /></div></div>

            </div>

            {/* <button onClick={checkSubs}>CHECK YOUR SUBS</button>*/}
            <div className="eventHeader">
                <h3 className="eventtitle">Events</h3>
                {firebase.auth().currentUser && <Link className="more" to={{ pathname: `/AffiliateEvents/${username}`, state: { id: location.state.id } }} >See More</Link>}
            </div>
            <div className="event32">
                {eventy.slice(0, 2).map(subs => (
                    <Eventfeed3 title={subs.title} picture={subs.pictures} start={subs.start} end={subs.end} location={subs.location} />
                ))}
            </div>
        </div>
    );
}